import { render, staticRenderFns } from "./singleEvent.vue?vue&type=template&id=7b57f49e"
import script from "./singleEvent.vue?vue&type=script&lang=js"
export * from "./singleEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports